import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "company_types"

export const CompanyTypeRepository = {
    gets : GeneratorRequest.gets(nomApi, true),
    delete: GeneratorRequest.delete(nomApi, true),
    put: GeneratorRequest.put(nomApi, true)
}
